require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-job-fairs-connecting-partners-and-alumni.json") })
        }
      }, "path---blog-job-fairs-connecting-partners-and-alumni");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-job-fairs-connecting-partners-and-alumni!./.cache/json/blog-job-fairs-connecting-partners-and-alumni.json
// module id = 912
// module chunks = 231608221292675